"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setShouldShowFinalizePaymentComponent = exports.finalizePaymentSlice = exports.fetchFinalizeInitialPayment = exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../api");
var _eventDispatcher = _interopRequireWildcard(require("../util/eventDispatcher"));
var _extraReducers;
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var initialState = {
  loading: false,
  payment: {
    paymentMethod: null,
    currency: null
  },
  error: null,
  shouldShowFinalizePaymentComponent: false
};
var fetchFinalizeInitialPayment = (0, _toolkit.createAsyncThunk)('finalizeInitialPayment', /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref, _ref2) {
    var orderId, details, rejectWithValue, _yield$finalizeInitia, payment;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          orderId = _ref.orderId, details = _ref.details;
          rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _context.next = 5;
          return (0, _api.finalizeInitialPayment)(orderId, details);
        case 5:
          _yield$finalizeInitia = _context.sent;
          payment = _yield$finalizeInitia.payment;
          return _context.abrupt("return", payment);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_context.t0.message));
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 10]]);
  }));
  return function (_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}());
exports.fetchFinalizeInitialPayment = fetchFinalizeInitialPayment;
var finalizePaymentSlice = (0, _toolkit.createSlice)({
  name: 'finalizeInitialPayment',
  initialState: initialState,
  reducers: {
    setShouldShowFinalizePaymentComponent: function setShouldShowFinalizePaymentComponent(state, _ref4) {
      var payload = _ref4.payload;
      state.shouldShowFinalizePaymentComponent = payload;
    }
  },
  extraReducers: (_extraReducers = {}, (0, _defineProperty2.default)(_extraReducers, fetchFinalizeInitialPayment.pending, function (state) {
    state.loading = true;
  }), (0, _defineProperty2.default)(_extraReducers, fetchFinalizeInitialPayment.fulfilled, function (state, _ref5) {
    var payload = _ref5.payload;
    state.loading = false;
    state.error = null;
    state.payment = payload;
    state.shouldShowFinalizePaymentComponent = true;
    (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_PURCHASE_SUCCESSFUL, {
      payload: payload
    });
  }), (0, _defineProperty2.default)(_extraReducers, fetchFinalizeInitialPayment.rejected, function (state, _ref6) {
    var payload = _ref6.payload;
    state.loading = false;
    state.error = payload;
    state.shouldShowFinalizePaymentComponent = true;
    (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_PURCHASE_FAILED, {
      payload: payload
    });
  }), _extraReducers)
});
exports.finalizePaymentSlice = finalizePaymentSlice;
var setShouldShowFinalizePaymentComponent = finalizePaymentSlice.actions.setShouldShowFinalizePaymentComponent;
exports.setShouldShowFinalizePaymentComponent = setShouldShowFinalizePaymentComponent;
var _default = finalizePaymentSlice.reducer;
exports.default = _default;